module.exports = __webpack_public_path__ + "./images/dd62ab3ee82962228311ae451e2c0915.jpg";